export default __webpack_public_path__ + "static/media/PPP.c96a5de3.png";